import { useMemo } from "react";
import { useMutation } from "react-query";

import { mapOptions } from "helpers";
import { dropdownValuesService } from "services";

const useMccCodes = () => {
	const { mutateAsync } = useMutation(
		async ({ search, prevOptions, page }: any) => {
			const { items, count } = await dropdownValuesService.getMccAliases({
				pattern: search,
				page,
			});

			const hasMore = prevOptions.length + items.length < count;

			const options = items.map(i => ({
				value: i.mcc_code,
				label: i.description,
				id: i.id,
			}));

			return {
				options,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		},
	);

	return useMemo(
		() => ({
			loadMccCodes: mapOptions(mutateAsync),
		}),
		[mutateAsync],
	);
};

export default useMccCodes;
